export default {
    url: 'power-backup',
    include: ['us', 'ca', 'au', 'kr'],
};
